import { combineReducers } from 'redux';
import produce from 'immer';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { CLEAR_UPDATED_THEME_SETTINGS, THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_BUFFER_SAVED, THEME_SETTINGS_FIELD_KEY_UPDATED, THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES, THEME_SETTINGS_UPDATED, MODULE_REDUCER_CHANGE_UNDO, MODULE_REDUCER_CHANGE_REDO, THEME_SETTINGS_CLEARED, THEME_SETTINGS_RESET, SET_ACTIVE_PRESET, CLEAR_ACTIVE_PRESET, THEME_SETTINGS_CHANGE_UNDONE, THEME_SETTINGS_CHANGE_REDONE, SET_UNIVERSAL_SCROLL_TO_FIELD_PATH } from '../actions/ActionTypes';
import requestStatusFactory from './factories/requestStatusFactory';
const hasBufferedChanges = (state = false, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = action.payload.hasChanges;
        return draft;
      }
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = true;
        return draft;
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        draft = false;
        return draft;
      }
    default:
      return draft;
  }
});
const hasUnsavedChanges = (state = false, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          draft = false;
          return draft;
        }
        return draft;
      }
    case THEME_SETTINGS_UPDATED:
    case THEME_SETTINGS_CLEARED:
    case THEME_SETTINGS_RESET:
    case SET_ACTIVE_PRESET:
    case CLEAR_ACTIVE_PRESET:
    case MODULE_REDUCER_CHANGE_UNDO:
    case MODULE_REDUCER_CHANGE_REDO:
      {
        draft = true;
        return draft;
      }
    default:
      return draft;
  }
});
const hasUnsavedPresetChanges = (state = false, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          draft = false;
          return draft;
        }
        return draft;
      }
    case SET_ACTIVE_PRESET:
    case CLEAR_ACTIVE_PRESET:
    case THEME_SETTINGS_CHANGE_UNDONE:
    case THEME_SETTINGS_CHANGE_REDONE:
    case MODULE_REDUCER_CHANGE_UNDO:
    case MODULE_REDUCER_CHANGE_REDO:
      {
        draft = true;
        return draft;
      }
    default:
      return draft;
  }
});
const activeFieldKey = (state = null, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_FIELD_KEY_UPDATED:
      {
        const {
          payload: fieldKey
        } = action;
        draft = fieldKey || null;
        return draft;
      }
    default:
      return draft;
  }
});
const lastSaveWasAutoSave = (state = false, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          payload
        } = action;
        if (payload) {
          draft = Boolean(payload.isAutoSave);
        }
        return draft;
      }
    default:
      return draft;
  }
});
const updatedSettings = (state = [], action) => produce(state, draft => {
  switch (action.type) {
    case THEME_SETTINGS_UPDATED:
      {
        const {
          payload
        } = action;
        if (payload) {
          draft = [...draft, payload.key];
          return draft;
        }
        return draft;
      }
    case CLEAR_UPDATED_THEME_SETTINGS:
      {
        draft = [];
        return draft;
      }
    default:
      return draft;
  }
});
const universalScrollToField = (state = '', action) => produce(state, draft => {
  switch (action.type) {
    case SET_UNIVERSAL_SCROLL_TO_FIELD_PATH:
      draft = action.payload || '';
      return draft;
    default:
      return draft;
  }
});
export default combineReducers({
  hasBufferedChanges,
  hasBufferdChangesRequestStatus: requestStatusFactory(THEME_SETTINGS_FETCHED_HAS_BUFFERED_CHANGES),
  activeFieldKey,
  publishRequestStatus: requestStatusFactory(THEME_SETTINGS_BUFFER_PUBLISHED),
  saveRequestStatus: requestStatusFactory(THEME_SETTINGS_BUFFER_SAVED),
  updatedSettings,
  lastSaveWasAutoSave,
  hasUnsavedChanges,
  hasUnsavedPresetChanges,
  universalScrollToField
});